const cleanParagraphs = () => {
	const paragraphs = document.querySelectorAll('p');
	let emptyParagraphFound = false;
	paragraphs.forEach(p => {
	if (p.textContent.trim() === '') {
		emptyParagraphFound = true;
		p.remove();
	}
	});
	if (emptyParagraphFound) {
	} else {
	}
};
export default cleanParagraphs;
